import { grey } from "@material-ui/core/colors";
import { escape } from "lodash";

export const UNRESOLVED_VARIABLE_KEY = "common.task.variable_unresolved";
export const UNRESOLVED_VARIABLE_DEFAULT = "variable is unresolved";

// Styled inline (not via a class) so the emphasis survives the email/PDF
// renderers that strip `<style>`/classes.
export const buildUnresolvedVariableHtml = (
  label: string = UNRESOLVED_VARIABLE_DEFAULT
) =>
  `<span style="color: ${grey[500]}; text-decoration: underline">${escape(
    label
  )}</span>`;

export const UNRESOLVED_VARIABLE_HTML = buildUnresolvedVariableHtml();
